import * as Factory from 'factory.ts'
import faker from 'faker'

import { type LegalEntitySummary } from './LegalEntitySummary'

export const LegalEntitySummaryFactory =
  Factory.Sync.makeFactory<LegalEntitySummary>({
    id: Factory.each(() => faker.random.number()),
    uuid: Factory.each(() => faker.random.uuid()),
    name: Factory.each(() => faker.company.companyName()),
  })
